import useGlobalSettings from '@components/_hooks/useGlobalSettings';
import Image from 'next/image'
import Link from 'next/link';

const HeaderLogo = () => {
    const { getSetting } = useGlobalSettings();
    const width = getSetting('header_logo_widthx', 260);
    const height = getSetting('header_logo_heightx', 60);

    return (
        <Link href='/'>
            <div style={{
                position: 'absoltute'
            }}>
                <Image style={{objectFit: 'contain'}} height={height} width={width} priority={true} src={ `/images/${process.env.brand.acronym}/logo-main.png` } alt={'logo-main'} quality={75}/>

            </div>
        </Link>
    )
}

export default HeaderLogo